import { render, staticRenderFns } from "./HomeCard.vue?vue&type=template&id=8c383506&scoped=true"
import script from "./HomeCard.vue?vue&type=script&lang=js"
export * from "./HomeCard.vue?vue&type=script&lang=js"
import style0 from "./HomeCard.vue?vue&type=style&index=0&id=8c383506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c383506",
  null
  
)

export default component.exports